import { render, staticRenderFns } from "./invoicesubmissionmanagement.vue?vue&type=template&id=07126cb8&scoped=true&"
import script from "./invoicesubmissionmanagement.vue?vue&type=script&lang=js&"
export * from "./invoicesubmissionmanagement.vue?vue&type=script&lang=js&"
import style0 from "./invoicesubmissionmanagement.vue?vue&type=style&index=0&id=07126cb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07126cb8",
  null
  
)

export default component.exports